//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ObjectAttribute } from "./types";

export interface AttributeTableProps extends HTMLAttributes<HTMLDivElement> {
  label?: ReactNode;
  items?: ObjectAttribute[];
}

/** Label-and-value rows for the object's remaining attributes. */
export function AttributeTable({
  label,
  items = [],
  className = "",
  ...rest
}: AttributeTableProps) {
  return (
    <div
      className={className}
      style={{ display: "flex", flexDirection: "column", gap: 10 }}
    >
      {label && <span className="bui-obj-section-label">{label}</span>}
      <div className="bui-attr-table" {...rest}>
        {items.map((item) => (
          <div key={item.label} className="bui-attr-table__row">
            <span className="bui-attr-table__label">{item.label}</span>
            <span className="bui-attr-table__value">{item.value ?? "—"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
